import React from 'react'

const Manual_ordenes_compra_revertir_parcialmente = () => {
  return (
    <>
     <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
        <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Ordenes de Compra - Revertir Parcialmente
        </h2>
        <p className="text-lg text-gray-700 mb-6">
        La guía facilita la reversión parcial de órdenes de compra, detallando cada paso para devolver
        productos de manera eficiente y sin errores. Permite una mejor gestión del inventario y las finanzas,
        optimizando tiempo y reduciendo complicaciones.
        </p>
        <iframe

        src="https://scribehow.com/embed/Ordenes_de_Compra__Revertir_Parcialmente__RRWvLZSZR-GZJ5iWacfJSQ?as=scrollable"
        className="scribe-iframe-general-22"
        width="100%"
        height="2900"
        allowFullScreen
        style={{ border: 0, minHeight: '640px' }}
        ></iframe>
        </div>
    </div>
    </>
  )
}

export default Manual_ordenes_compra_revertir_parcialmente